"use client";

import { useMemo } from "react";
import Link from "@/components/common/Link";
import LogoImage from "@/components/common/LogoImage";
import { CLIENT_LOGO_INFO, INTERVIEWS } from "@/constants/clients";
import { CLIENT_INTERVIEW_IMAGE_PATH, PATH } from "@/constants/path";
import { useBatchImpressionTracking } from "@/hooks/useImpressionTracking";
import { trackEvent } from "@/utils/analytics";

import Interview from "./Interview";

function InterviewSection() {
  const impressionEvents = useMemo(
    () =>
      INTERVIEWS.map(({ client }, i) => ({
        eventName: "testimonial_impression",
        params: {
          company_name: CLIENT_LOGO_INFO[client].name,
          card_position: i + 1,
        },
      })),
    [],
  );

  const sectionRef = useBatchImpressionTracking<HTMLDivElement>(impressionEvents);

  const handleTestimonialClick = (companyName: string, position: number) => {
    trackEvent("testimonial_click", {
      company_name: companyName,
      card_position: position,
    });
  };

  return (
    <div ref={sectionRef} className="mt-20 flex flex-col items-center justify-center gap-6 px-side">
      <div className="grid w-full max-w-[1200px] grid-cols-1 gap-4 tablet:grid-cols-3">
        {INTERVIEWS.map(({ client, content, slug }, i) => (
          <Interview
            key={`interview-${client}`}
            href={PATH.BLOG_DETAIL(slug)}
            image={{
              src: CLIENT_INTERVIEW_IMAGE_PATH({ client }),
              alt: client,
            }}
            title={<LogoImage client={client} />}
            content={content}
            onClick={() => handleTestimonialClick(CLIENT_LOGO_INFO[client].name, i + 1)}
          />
        ))}
      </div>
      <Link href={PATH.BLOG} text="더 많은 이야기 읽어보기" />
    </div>
  );
}

export default InterviewSection;
